export default {
  nailDesign(state) {
    return state.nailDesign
  },
  nailDesigns(state) {
    return state.nailDesigns
  },
  nailDesignTags(state) {
    return state.nailDesignTags
  },
  nailDesignFilters(state) {
    return state.nailDesignFilters
  },
  getNailDesignById: state => nailDesignId => state.nailDesigns.find(nailDesign => nailDesign.id === nailDesignId),
}
